import AppNaijaTradeMall from '@/pages/AppNaijaTradeMall/Template'
import Points from '@/pages/AppNaijaTradeMall/Points'
import Order from '@/pages/AppNaijaTradeMall/Order'
import Account from '@/pages/AppNaijaTradeMall/Account'
export default {
    path: '/AppNaijaTradeMall',
    component: AppNaijaTradeMall,
    children: [
        {
            path: '',
            name: 'AppNaijaTradeMallPoints',
            component: Points,
        },
        {
            path: ':id/:id1',
            name: 'AppNaijaTradeMallOrder',
            component: Order,
        },
        {
            path: 'account',
            name: 'AppNaijaTradeMallAccount',
            component: Account,
        },
    ]
}


// WEBPACK FOOTER //
// ./src/router/appnaijatrademall.js